<template>
  <v-dialog v-model="dialog" max-width="800">
    <v-card>
      <v-card-title>
        <span class="text-subtitle-1 font-weight-bold">Tipi di Stagione</span>
        <v-spacer />
        <v-btn icon @click="dialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pa-0">
        <v-row no-gutters style="min-height: 400px">
          <!-- Colonna sinistra: form -->
          <v-col cols="12" md="5" class="pa-6">
            <div class="d-flex align-center mb-4">
              <span class="text-subtitle-2 font-weight-medium">
                {{ tipo_in_modifica ? 'Modifica Tipo' : 'Nuovo Tipo' }}
              </span>
              <v-spacer></v-spacer>
              <v-btn v-if="tipo_in_modifica" text small color="grey" @click="annullaModifica">
                <v-icon small class="mr-1">mdi-close</v-icon>
                Annulla
              </v-btn>
            </div>
            <v-form ref="form" v-model="formValid">
              <v-text-field
                v-model="tipo.nome"
                label="Nome"
                :rules="[(v) => !!v || 'Campo obbligatorio']"
                required
                outlined
                dense
              />
              <v-text-field
                v-model.number="tipo.ordine"
                label="Ordine visualizzazione"
                type="number"
                min="0"
                outlined
                dense
                hint="Lascia vuoto per ordinamento automatico"
                persistent-hint
              />
            </v-form>
            <v-alert v-if="saveError" type="error" outlined dense class="mt-3">
              {{ saveError }}
            </v-alert>
            <div class="d-flex justify-end mt-4">
              <v-btn
                color="primary"
                :loading="loading_save"
                :disabled="!formValid"
                @click="salva"
              >{{ tipo_in_modifica ? 'Aggiorna' : 'Salva' }}</v-btn>
            </div>
          </v-col>

          <v-divider vertical />

          <!-- Colonna destra: lista -->
          <v-col cols="12" md="7" class="pa-6">
            <div class="d-flex align-center text-subtitle-2 font-weight-medium mb-4">
              <v-icon class="mr-2">mdi-calendar-multiple</v-icon>
              Tipi disponibili
            </div>
            <v-alert v-if="deleteError" type="error" outlined dense class="mb-3">
              {{ deleteError }}
            </v-alert>
            <v-progress-linear v-if="loading_tipi" indeterminate class="mb-4" />
            <v-alert v-else-if="!tipiStagione.length" type="info" outlined dense>
              Nessun tipo stagione configurato.
            </v-alert>
            <v-list v-else dense class="py-0 rounded-lg white">
              <v-list-item
                v-for="item in tipiStagione"
                :key="item.id"
              >
                <v-list-item-avatar size="28" class="mr-3">
                  <v-avatar color="deep-orange lighten-4" size="28">
                    <span class="text-caption font-weight-bold deep-orange--text">
                      {{ item.ordine != null ? item.ordine : '—' }}
                    </span>
                  </v-avatar>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title class="text-body-2">{{ item.nome }}</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="flex-row align-center" style="gap: 4px;">
                  <v-btn icon small color="primary" @click="apriModifica(item)">
                    <v-icon small>mdi-pencil</v-icon>
                  </v-btn>
                  <v-btn
                    icon
                    small
                    color="red"
                    :loading="deletingId === item.id"
                    :disabled="deletingId === item.id"
                    @click="elimina(item)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "GestioneTipiStagioneDialog",
  data() {
    return {
      dialog: false,
      formValid: false,
      loading_save: false,
      loading_tipi: false,
      deletingId: null,
      saveError: "",
      deleteError: "",
      tipo_in_modifica: null,
      tipo: {
        nome: "",
        ordine: null,
      },
    };
  },
  computed: {
    tipiStagione() {
      return this.$store.getters.getTipiStagione || [];
    },
  },
  methods: {
    openDialog() {
      this.dialog = true;
      if (!this.tipiStagione.length) {
        this.loading_tipi = true;
        this.$store.dispatch("fetchTipiStagione").finally(() => {
          this.loading_tipi = false;
        });
      }
    },
    resetForm() {
      this.tipo = { nome: "", ordine: null };
      this.tipo_in_modifica = null;
      this.saveError = "";
      if (this.$refs.form) this.$refs.form.resetValidation();
    },
    apriModifica(item) {
      this.tipo_in_modifica = item;
      this.tipo = { nome: item.nome, ordine: item.ordine };
      this.saveError = "";
    },
    annullaModifica() {
      this.resetForm();
    },
    async salva() {
      if (!this.$refs.form.validate()) return;
      this.loading_save = true;
      this.saveError = "";
      const payload = {
        nome: this.tipo.nome,
        ordine: this.tipo.ordine != null ? this.tipo.ordine : null,
      };
      try {
        if (this.tipo_in_modifica) {
          await this.$store.dispatch("updateTipoStagione", {
            id: this.tipo_in_modifica.id,
            payload,
          });
        } else {
          await this.$store.dispatch("saveTipoStagione", payload);
        }
        this.resetForm();
      } catch (e) {
        this.saveError =
          e?.response?.data?.error || "Errore durante il salvataggio. Riprova.";
      } finally {
        this.loading_save = false;
      }
    },
    async elimina(item) {
      this.deletingId = item.id;
      this.deleteError = "";
      try {
        await this.$store.dispatch("deleteTipoStagione", item.id);
        if (this.tipo_in_modifica?.id === item.id) this.resetForm();
      } catch (e) {
        this.deleteError =
          e?.response?.data?.error || "Impossibile eliminare il tipo stagione.";
      } finally {
        this.deletingId = null;
      }
    },
  },
};
</script>
